module.exports = __webpack_public_path__ + "img/conahcyt-azul.43bb0a54.svg";